import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: 380,
      overflowY: 'auto',

      border: `1px solid #D2D2D2`,
      borderRadius: 5,
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      '& .MuiTableCell-root': {
        margin: 0,
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      },
    },
    body: {
      '& :first-child td': {
        backgroundColor: '#F4F4F4',
      },
      '& td': {
        borderRadius: 6,
      },
      '& tr :first-child:not(:only-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      '& tr :last-child:not(:only-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },
    table: {
      borderCollapse: 'separate',
      borderSpacing: `0 1rem`,
    },
    listItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap',
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(1),
      position: 'relative',
      '&::before': {
        content: '"\\2022"',
        position: 'absolute',
        left: -15,
      },
    },
    label: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      fontSize: '1.2rem',
      position: 'relative',
    },
    row: {
      '& :first-child': {
        borderLeftWidth: 1,
      },
      '& :last-child': {
        borderRightWidth: 1,
      },
    },
    accordionRow: {
      '& .MuiTableCell-root': {
        padding: 0,
        border: 0,
      },
    },
  }),
)
